import { instanceWithAuth } from "@/api/index";

function getContactList(searchData) {
    return instanceWithAuth.get("/customers/contact-history", { params: searchData });
}

export { getContactList };
